import { render, staticRenderFns } from "./ConfirmationPopover.vue?vue&type=template&id=1921d002&scoped=true"
import script from "./ConfirmationPopover.vue?vue&type=script&lang=js"
export * from "./ConfirmationPopover.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationPopover.vue?vue&type=style&index=0&id=1921d002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1921d002",
  null
  
)

export default component.exports